import { protectWorkspaceAccessBeforeLoad } from '@routes/-protectWithPermission'
import { withCompanyName } from '@routes/-withCompanyName'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { DateRangeContextProvider } from 'features/commonUI'
import { isLibraryCategory, SDKIntegrationHealthPage } from 'features/integrations'
import { canViewAnalyticsPermission } from 'hooks/usePermission'

import { redirectOnUnknownIntegration } from '.'

function WrappedSDKIntegrationHealthPage() {
  return (
    <DateRangeContextProvider>
      <SDKIntegrationHealthPage />
    </DateRangeContextProvider>
  )
}

export const Route = createFileRoute(
  '/_authenticated/_layout/workspaces/$subscriptionId/integrations/$integrationTag/health'
)({
  component: WrappedSDKIntegrationHealthPage,
  beforeLoad: async ({ params, context }) => {
    await protectWorkspaceAccessBeforeLoad(canViewAnalyticsPermission, undefined, { context, params })
    const integration = redirectOnUnknownIntegration(params)

    if (!isLibraryCategory(integration.category)) {
      throw redirect({
        to: '/workspaces/$subscriptionId/integrations/$integrationTag',
        params: {
          subscriptionId: params.subscriptionId,
          integrationTag: params.integrationTag,
        },
      })
    }

    return {
      integration,
    }
  },
  loader: ({ context }) => ({
    integration: context.integration,
  }),
  head: ({ loaderData }) => ({
    meta: [
      {
        title: withCompanyName(`Library Health ${loaderData ? `- ${loaderData.integration.title}` : ''}`),
      },
    ],
  }),
})
